import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { Box, Fade } from '@mui/material'
import Link from 'next/link'
import { Button, Input, Typography } from '@evocolabs/orkaui'
import { useEffect, useState } from 'react'
import { validateEmail } from '@/src/utils/Validater'

import { classes } from '@/src/components/Blog/[blogTitle].module.js'

export const BlogFooter = ({ usePC, emailSubscribe, theme, blogTitle }) => {
  const [emailInputClicked, setEmailInputemailInputClicked] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [email, setEmail] = useState('')
  const [terms, setTerms] = useState(false)
  const [errors, setErrors] = useState({
    term: '',
    email: ''
  })
  const [optionContent, setOptionContent] = useState(null)

  useEffect(() => {
    if (emailInputClicked) {
      setOptionContent(
        <Typography variant="body3">
          {`I agree to Orka's `}
          <Link href={'/legal/PrivacyPolicy'}>
            <Typography variant="Link">Privacy Policy</Typography>
          </Link>{' '}
          and{' '}
          <Link href={'/legal/TermsOfService'}>
            <Typography variant="Link">Terms of Service</Typography>
          </Link>
          .
        </Typography>
      )
    }
    if (submitted) {
      setOptionContent(null)
    }
  }, [emailInputClicked, submitted])
  const handleEmailInputChanged = (ipt) => {
    setEmail(ipt.target.value)
    setErrors({ ...errors, email: '' })
  }
  const handleEmailInputemailInputClicked = () => {
    setEmailInputemailInputClicked(true)
  }
  const handleTermsClick = () => {
    setTerms(!terms)
    if (!terms) {
      setErrors({ ...errors, term: '' })
    }
  }
  const handleEmailSubmitted = () => {
    const currentErrors = { ...errors }
    let checkError
    if (!terms) {
      currentErrors.term =
        'Please agree to our terms of services and privacy policy'
      checkError = true
    }
    if (!validateEmail(email)) {
      currentErrors.email = 'Invalid email address'
      checkError = true
    }
    setErrors(currentErrors)
    if (!checkError) {
      const data = {
        email: email,
        page: `blogPage/${blogTitle}`
      }
      emailSubscribe(data)
      setSubmitted(true)
    }
  }
  // enter key down also submit
  const emailSubmitEnterDown = () => (e) => {
    if (e.keyCode === 13) {
      handleEmailSubmitted()
    }
  }

  return (
    <Box className={classes.blogFooter}>
      <img
        src={
          'https://d2mhexn86y1lr4.cloudfront.net/website/imgs/blog_footer.png'
        }
        style={
          usePC
            ? { height: '100%', width: '50%' }
            : { height: 'auto', width: '100%' }
        }
      />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          padding: { xs: '40px 24px', md: '0px 64px' },
          background: '#F3F3F3',
          borderRadius: {
            xs: '0px 0px 16px 16px',
            md: '0px 16px 16px 0px'
          },
          width: { xs: '100%', md: '50%' },
          textAlign: 'center'
        }}
      >
        <Typography variant="h2" sx={{ textAlign: 'center' }}>
          Want to Know More About Hearing Aids?{' '}
        </Typography>
        <Typography
          variant="body2"
          sx={{ marginTop: '16px', textAlign: 'center' }}
        >
          {`Subscribe to Orka's channel to get exclusive offers and the
                    latest product updates! `}
        </Typography>
        <div>
          <Box className={classes.footerEmail}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                width: usePC ? '67.5%' : '100%',
                maxWidth: '345px'
              }}
            >
              <Input
                disabled={submitted}
                placeholder="Your Email"
                value={email}
                type="email"
                fullWidth
                controlSx={{
                  marginTop: '16px'
                }}
                inputsx={{
                  border: '1px solid #FFFFFF',
                  height: '56px',
                  width: '100%',
                  '&.Mui-error': {
                    background: 'transparent'
                  },
                  [theme.breakpoints.down('lg')]: {
                    margin: 'auto',
                    background: 'rgba(255, 255, 255, 0.2)'
                  }
                }}
                onChange={handleEmailInputChanged}
                onClick={handleEmailInputemailInputClicked}
                onKeyDown={emailSubmitEnterDown()}
                errormsg={errors.email}
                option={optionContent}
                optionProps={{
                  error: terms,
                  errormsg: errors.term,
                  onClick: handleTermsClick,
                  checked: terms
                }}
              />
              {submitted && (
                <Typography variant="Body4">
                  Thank you for joining us!
                </Typography>
              )}
            </div>
            {submitted ? (
              usePC && (
                <Fade in={submitted} timeout={500}>
                  <CheckCircleIcon
                    className={classes.footerCheckButton}
                    disabled
                  />
                </Fade>
              )
            ) : (
              <Button
                id="submit"
                handleClick={handleEmailSubmitted}
                sx={{ height: '56px' }}
              >
                Subscribe
              </Button>
            )}
          </Box>
        </div>
      </Box>
    </Box>
  )
}
